import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { Paperclip } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

const AttachmentFilterNode = ({ data, selected }: NodeProps) => {
    return (
        <BaseNodeUI
            title={data.label || "Attachment Filter"}
            icon={Paperclip}
            colorClass="text-slate-600"
            bgClass="bg-slate-100"
            selected={selected}
            isRunning={data?.executionStatus === 'Running'} executionStatus={data?.executionStatus}
            rowsProcessed={data?.rowsAffected}
        />
    );
};

export default memo(AttachmentFilterNode);
